// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./$.iobject')
  , defined = require('./$.defined');
module.exports = function(it){
  return IObject(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.to-iobject.js
// module id = KQgK
// module chunks = 1